import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import ImageView from 'lib/images/image-view';
import SVGIconView from 'lib/images/svg-icon-view';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';
import IconMember from 'four-nets/icons/svg/icon_members.svg';
import IconFeed from 'four-nets/icons/svg/icon_feed.svg';
import { GroupTileFragment } from 'four-nets/photoblog/groups/groups/group.graphql';

import defaultStyles from './group.scss';

export interface Props extends GroupTileFragment {
    styles: typeof defaultStyles;
}

class Group extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.group}>
                <Link to={this.props.href} className={styles.link}>
                    <div className={styles.image}>
                        {this.props.coverPhoto ? (
                            <FormattedMessage id='GROUP_COVER_PHOTO'>
                                {msg => (
                                    <ImageView
                                        aspectFill={true}
                                        srcSet={this.props.coverPhoto!.srcset!}
                                        src={this.props.coverPhoto!.src}
                                        sizes={{ xs: 200 }}
                                        alt={`${this.props.name} - ${msg}`}
                                        linkify={false}
                                    />
                                )}
                            </FormattedMessage>
                        ) : null}
                    </div>
                </Link>
                <div className={styles.groupInfo}>
                    <Link to={this.props.href} className={styles.link}>
                        <h3 className={styles.groupName}>
                            <TextShortener text={this.props.name ? this.props.name : ''} textLength={48} />
                        </h3>
                    </Link>
                    <div className={styles.groupStats}>
                        {this.props.viewerUnreadCount ? (
                            <div className={styles.postText}>
                                <SVGIconView className={styles.statImage} src={IconFeed} />
                                <FormattedMessage
                                    id='GROUP_NEW_POSTS'
                                    values={{ counter: this.props.viewerUnreadCount }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Group);
